import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/*
	This file exists as part of the 'rovo_chat_jira_nl_to_jql_minion_in_fe' feature.
	It can be freely deleted if the feature is being removed.
*/

export type JiraNLToJQLData = {
	jql: string;
};

export interface JiraNLToJQLCommandProperties extends CommandProperties {
	data: JiraNLToJQLData[];
}

export type JiraNLToJQLCommandResult = {
	success: boolean;
	error?: string;
};

export const JiraNLToJQLCommand = createCommand<
	JiraNLToJQLCommandProperties,
	JiraNLToJQLCommandResult
>('jira-jql-submit-command');
